<template>
  <transition name="fade">
    <div
      v-show="isActive"
      class="fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-black bg-opacity-50 py-4 z-50"
      @click="$store.commit('setActiveModal', '')"
    >
      <div
        class="w-full max-w-md max-h-full h-auto text-gray-900 bg-gray-100 rounded-lg p-4 overflow-auto"
        @click.stop="() => {}"
      >
        <div class="flex flex-col gap-3">
          <button class="ml-auto" @click="$store.commit('setActiveModal', '')">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-6 h-6"
            >
              <path
                fill-rule="evenodd"
                d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <div class="uppercase text-center text-sm text-gray-700">Update username</div>

          <input
            ref="nameInput"
            v-model="playerNameInput"
            type="text"
            maxlength="64"
            placeholder="Your name"
            class="w-full px-3 py-2 rounded bg-white text-gray-900 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black/20"
            @keydown.enter.prevent="save"
          />

          <div v-if="error" class="text-center text-xs text-red-700">
            {{ error }}
          </div>

          <div class="flex gap-2 justify-center">
            <button
              class="px-3 py-2 rounded bg-black text-white text-sm"
              :disabled="isSaving"
              @click="save"
            >
              {{ isSaving ? "Saving…" : "Save" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import { socket } from "../../main";

export default {
  name: "EndlessUpdateNameModal",

  data() {
    return {
      playerNameInput: "",
      error: "",
      isSaving: false,
    };
  },

  computed: {
    ...mapGetters({
      activeModal: "getActiveModal",
    }),

    isActive() {
      return this.activeModal === "endless_update_name_modal";
    },
  },

  watch: {
    isActive(newValue) {
      if (!newValue) return;
      this.error = "";
      this.isSaving = false;
      this.playerNameInput = (window.localStorage.getItem("endlessPlayerName") || "").trim();

      this.$nextTick(() => {
        const el = this.$refs.nameInput;
        if (el && typeof el.focus === "function") el.focus();
      });
    },
  },

  mounted() {
    socket.on("endlessPlayerNameSaved", this.handleNameSaved);
  },

  beforeDestroy() {
    socket.off("endlessPlayerNameSaved", this.handleNameSaved);
  },

  methods: {
    save() {
      this.error = "";

      const trimmed = (this.playerNameInput || "").trim().slice(0, 64);
      if (!trimmed) {
        this.error = "Enter a name.";
        return;
      }

      const gameId = window.localStorage.getItem("gameId");
      if (!gameId) {
        this.error = "Missing game id.";
        return;
      }

      window.localStorage.setItem("endlessPlayerName", trimmed);
      this.isSaving = true;
      socket.emit("setEndlessPlayerName", { gameId, name: trimmed });
    },

    handleNameSaved(payload) {
      if (!this.isSaving) return;
      this.isSaving = false;

      if (!payload || payload.gameId !== window.localStorage.getItem("gameId")) return;
      if (typeof payload.name !== "string") return;

      window.localStorage.setItem("endlessPlayerName", payload.name.trim());
      this.playerNameInput = payload.name.trim();
      this.$store.commit("setActiveModal", "");
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/modals/EndlessUpdateNameModal.vue